function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4L14 10H20L15.5 14L17 20L12 16.01L7 20L8.5 14L4 10H10L12 4ZM22 10C22 8.9 21.11 8 20 8H15.44L13.9 3.37C13.63 2.55 12.87 2 12.01 2C11.15 2 10.37 2.55 10.1 3.37L8.56 8H4C2.89 8 2 8.9 2 10C2 10.61 2.27 11.16 2.71 11.53L6.26 14.69L5.05 19.51C4.84 20.34 5.19 21.22 5.91 21.68C6.24 21.89 6.62 22 6.99 22C7.44 22 7.88 21.85 8.24 21.56L12 18.57L15.76 21.56C16.12 21.85 16.56 22 17.01 22C17.38 22 17.76 21.89 18.09 21.68C18.81 21.22 19.16 20.34 18.95 19.51L17.74 14.69L21.29 11.53C21.73 11.16 22 10.61 22 10Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Star.js.map